import { Skeleton } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { TaskId } from 'api/models';
import { DependentTask } from 'api/tasks';
import { TaskStatusPicker } from 'components/atoms/tasks';
import { BodyShort01, HelperText, SingleLineEllipsis } from 'components/styles';
import { useTaskDetailStore } from 'data/tasks/hooks';
import { useNavigateToTask } from 'hooks/use-navigate-to-task';

const PrimaryRow = styled.div`
  ${BodyShort01};
  ${SingleLineEllipsis};
  color: var(--gray-100);
  width: 90%;
`;
const SecondaryRow = styled.div`
  ${HelperText};
  ${SingleLineEllipsis};
  width: 90%;
`;

const Container = styled.div`
  width: 360px;
  display: flex;
  align-items: center;
`;

const TextWrapper = styled.div`
  width: 90%;
  cursor: pointer;
`;

interface Props {
  record: DependentTask;
}

export const TaskNameColumnRenderer: FC<Props> = ({ record }) => {
  const { taskId, project } = record;
  const projectId = project?.projectId;
  const { data, isLoading } = useTaskDetailStore(TaskId(projectId, taskId));
  const navigateToTask = useNavigateToTask();

  if (isLoading) {
    return <Skeleton paragraph={false} title={{ width: 320 }} />;
  }

  const openTaskPane = () => {
    navigateToTask(TaskId(projectId, taskId));
  };

  return data ? (
    <Container>
      <TaskStatusPicker
        disabled
        size="middle"
        projectId={projectId}
        taskId={taskId}
        type={data.type}
        fields={data.fields}
        progress={data.progress}
      />
      <TextWrapper onClick={openTaskPane}>
        <PrimaryRow title={data.taskName}>{data.taskName}</PrimaryRow>
        <SecondaryRow title={data.projectPhase?.projectPhaseName}>
          {data.projectPhase?.projectPhaseName}
        </SecondaryRow>
      </TextWrapper>
    </Container>
  ) : null;
};
